import React, { useState, useEffect } from 'react';
import { toastManager, Toast } from '../utils/toast';
import './ToastContainer.css';

const ToastContainer: React.FC = () => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const unsubscribe = toastManager.subscribe(setToasts);
    return unsubscribe;
  }, []);

  return (
    <div className="custom-toast-container">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`custom-toast custom-toast-${toast.type}`}
          onClick={() => toastManager.remove(toast.id)}
        >
          <div className="custom-toast-content">
            <span className="custom-toast-message">{toast.message}</span>
            <button className="custom-toast-close" onClick={() => toastManager.remove(toast.id)}>
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;




